import { connect } from 'react-redux';

import {
  getActCanceledReasonBlockId,
  getActCreationActDateTimeBlockId,
  getActDocumentAttachmentsBlockId,
} from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { IKnmErknmFormAct } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormAct';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getCatalogsKnmCanceledReasonsSelectOptions } from 'CorePackage/CatalogsModule/selectors/catalogsSelectors';
import { IKnmCanceledReasonSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmCancelledReasonsSelectOption';
import { DatePickerField } from 'UIPackage/MainModule/components/DatePickerField';
import { getTitleFieldWithRedStar } from 'functions/getTitleFieldWithRedStar';
import { KnmLateFieldsRemark } from 'KnmPackage/KnmLateFieldsRemarkModule/components/KnmLateFieldsRemark';

import { ErknmActDocument } from '../ErknmActDocument';
import { getKnmFormRef } from '../../../../KnmPackage/MainModule/selectors/knmSelectors';
import styles from '../ErknmActsItem.module.scss';

interface IErknmActsItemProps {
  id: string;
  index: number;
  isWatchOnly: boolean;
  name: string;
  value: IKnmErknmFormAct;
  isDisabledByComplete: boolean;
  isPaperless: boolean;
  isPm?: boolean;
  isDecision?: boolean;
  lateFieldName: string;
}

interface IErknmActsItemStoreProps {
  formRef: IKnmFormRef | undefined;
  knmCanceledReasonsOptions: IKnmCanceledReasonSelectOption[] | undefined;
}

const ErknmActsItemContentImpossibleWithoutStore = ({
  id,
  index,
  isWatchOnly,
  name,
  value,
  formRef,
  knmCanceledReasonsOptions,
  isDisabledByComplete,
  isPaperless,
  isPm,
  isDecision,
  lateFieldName,
}: IErknmActsItemProps & IErknmActsItemStoreProps) => {
  const canceledReasonBlockId = getActCanceledReasonBlockId(id);
  const documentAttachmentsBlockId = getActDocumentAttachmentsBlockId(id);

  return (
    <>
      {!isPaperless && (
        <FieldBlock id={documentAttachmentsBlockId}>
          <ErknmActDocument
            isWatchOnly={isWatchOnly}
            name={`${name}.document.attachments`}
            attachmentsNumber={value.document?.attachments?.length || 0}
            id={documentAttachmentsBlockId}
            index={index}
            formRef={formRef}
            lateFieldName={
              value.document?.attachments && value.document?.attachments[0]?.guid
                ? `${lateFieldName}/document/attachments/${value.document?.attachments[0]?.guid}/fileName`
                : undefined
            }
          />
        </FieldBlock>
      )}
      {isPaperless && (
        <Row>
          <FieldBlock size="col-6">
            <div className={styles.ExcerptLink}>Выписка</div>
          </FieldBlock>
          <FieldBlock
            label={getTitleFieldWithRedStar({
              label: `Дата и время составления акта о невозможности проведения`,
              field: `${name}.creationActDateTime`,
              isPm,
              isDecision,
              isKnm: !isPm && !isDecision,
            })}
            color="black"
            placementLabel="left"
            size="half"
            type="not-space"
            className={styles.CreationDateBlock}
            id={getActCreationActDateTimeBlockId(value.listId)}
          >
            <DatePickerField
              className={styles.DatePickerField}
              name={`${name}.creationActDateTime`}
              disabled={true}
              timeFormat
            />
          </FieldBlock>
        </Row>
      )}
      <Row>
        <FieldBlock
          label={getTitleFieldWithRedStar({
            label: `Причина невозможности проведения`,
            field: `${name}.canceledReason`,
            isPm,
            isDecision,
            isKnm: !isPm && !isDecision,
          })}
          color="black"
          id={canceledReasonBlockId}
          tooltip={
            <KnmLateFieldsRemark lateFieldPath={`${lateFieldName}/canceledReason`} fieldId={canceledReasonBlockId} />
          }
        >
          <SelectInputField
            name={`${name}.canceledReason`}
            options={knmCanceledReasonsOptions}
            size="medium"
            disabled={isWatchOnly || isDisabledByComplete}
            isClearable={false}
          />
        </FieldBlock>
      </Row>
    </>
  );
};

const mapStateToProps = (state: IRootState): IErknmActsItemStoreProps => ({
  formRef: getKnmFormRef(state),
  knmCanceledReasonsOptions: getCatalogsKnmCanceledReasonsSelectOptions(state),
});

export const ErknmActsItemContentImpossible = connect(mapStateToProps)(ErknmActsItemContentImpossibleWithoutStore);
